import Vue from 'vue'
import store from '../store'
import routes from './routes'
import Router from 'vue-router'
import {sync} from 'vuex-router-sync'
import {EventBus} from '../utils/event-bus';

Vue.use(Router);

// The middleware for every page of the application.
const globalMiddleware = ['receive-resource-token'];

// Load middleware modules dynamically.
const routeMiddleware = resolveMiddleware(
  require.context('../middlewares', false, /.*\.js$/)
);

const router = createRouter();

sync(store, router);

export default router

/**
 * Create a new router instance.
 *
 * @return {Router}
 */
function createRouter() {
  const router = new Router({
    mode: 'history',
    linkActiveClass: 'open active',
    routes
  })

  router.beforeEach(beforeEach)
  router.afterEach(afterEach)

  return router
}

/**
 * Global router guard.
 *
 * @param {Route} to
 * @param {Route} from
 * @param {Function} next
 */
async function beforeEach(to, from, next) {
  // Get the matched components and resolve them.

  EventBus.$emit('wk-lazy-comp-ready', false);
  // store.dispatch('css/clearCss');

  const components = await resolveComponents(
    router.getMatchedComponents({...to})
  );

  if (components.length === 0) {
    return next()
  }
  // Get the middleware for all the matched components.
  const middleware = getMiddleware(components)

  // Call each middleware.
  callMiddleware(middleware, to, from, (...args) => {
    next(...args)
  })
}

/**
 * Global after hook.
 *
 * @param {Route} to
 * @param {Route} from
 * @param {Function} next
 */
async function afterEach(to, from, next) {
  await router.app.$nextTick()
}

/**
 * Call each middleware.
 *
 * @param {Array} middleware
 * @param {Route} to
 * @param {Route} from
 * @param {Function} next
 */
function callMiddleware(middleware, to, from, next) {

  const stack = middleware.reverse();

  const _next = (...args) => {
    // Stop if "_next" was called with an argument or the stack is empty.

    if (args.length > 0 || stack.length === 0) {
      return next(...args)
    }

    const middleware = stack.pop();

    if (typeof middleware === 'function') {
      middleware(to, from, _next)
    }
    else if (routeMiddleware[middleware]) {
      routeMiddleware[middleware](to, from, _next)
    }
    else {
      throw Error(`Undefined middleware [${middleware}]`)
    }
  };

  _next()
}

/**
 * Resolve async components.
 *
 * @param  {Array} components
 * @return {Array}
 */
function resolveComponents(components) {

  return Promise.all(components.map(component => {
    return typeof component === 'function' ? component() : component
  }))
}

/**
 * Merge the global middleware with the components' middleware.
 *
 * @param  {Array} components
 * @return {Array}
 */
function getMiddleware(components) {
  const middleware = [...globalMiddleware]

  components.filter(c => c.middleware).forEach(component => {
    if (Array.isArray(component.middleware)) {
      middleware.push(...component.middleware)
    } else {
      middleware.push(component.middleware)
    }
  })

  return middleware
}

/**
 * @param  {Object} requireContext
 * @return {Object}
 */
function resolveMiddleware(requireContext) {
  return requireContext.keys()
    .map(file =>
      [file.replace(/(^.\/)|(\.js$)/g, ''), requireContext(file)]
    )
    .reduce((guards, [name, guard]) => (
      {...guards, [name]: guard.default}
    ), {})
}



// WEBPACK FOOTER //
// ./src/router/index.js